import React from 'react';
import { IconProps } from '.';

const SvgPicture = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M4.25 9a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM7 7.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M1.25 3.25h21.5v17.5H1.25V3.25Zm1.5 1.5v14.5h2.928l9.808-10.324 5.764 5.763V4.75H2.75Zm18.5 12.06-5.736-5.736-7.767 8.176H21.25v-2.44Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPicture;
